import { createGatewayName, deleteGatewayName, editGatewayName, getListOfGatewayName } from "../types/gateway_name_list_types";

export const getListOfGatewayNameRequest = (payload, cb) => ({
  type: getListOfGatewayName.GET_LIST_OF_GATEWAY_NAME_REQUEST,
  payload,
  cb,
});
export const getListOfGatewayNameSuccess = (payload) => ({
  type: getListOfGatewayName.GET_LIST_OF_GATEWAY_NAME_SUCCESS,
  payload,
});
export const getListOfGatewayNameError = (payload) => ({
  type: getListOfGatewayName.GET_LIST_OF_GATEWAY_NAME_ERROR,
  payload,
});

export const createGatewayNameRequest = (payload, cb) => ({
  type: createGatewayName.CREATE_GATEWAY_NAME_REQUEST,
  payload,
  cb,
});
export const createGatewayNameSuccess = (payload) => ({
  type: createGatewayName.CREATE_GATEWAY_NAME_SUCCESS,
  payload,
});
export const createGatewayNameError = (payload) => ({
  type: createGatewayName.CREATE_GATEWAY_NAME_ERROR,
  payload,
});

export const editGatewayNameRequest = (payload, cb) => ({
  type: editGatewayName.EDIT_GATEWAY_NAME_REQUEST,
  payload,
  cb,
});
export const editGatewayNameSuccess = (payload) => ({
  type: editGatewayName.EDIT_GATEWAY_NAME_SUCCESS,
  payload,
});
export const editGatewayNameError = (payload) => ({
  type: editGatewayName.EDIT_GATEWAY_NAME_ERROR,
  payload,
});

export const deleteGatewayNameRequest = (payload, cb) => ({
  type: deleteGatewayName.DELETE_GATEWAY_NAME_REQUEST,
  payload,
  cb,
});
export const deleteGatewayNameSuccess = (payload) => ({
  type: deleteGatewayName.DELETE_GATEWAY_NAME_SUCCESS,
  payload,
});
export const deleteGatewayNameError = (payload) => ({
  type: deleteGatewayName.DELETE_GATEWAY_NAME_ERROR,
  payload,
});
